export const THEME_STORAGE_KEY = 'theme'
export const DEFAULT_THEME = 'system'
